import useSWR from 'swr';
import { getAllLanguages, getLanguagesByIds } from './languagesService';
import { useLanguagesStore } from './languagesStore';

export function useLanguages() {
	const { setLanguages } = useLanguagesStore();

	return useSWR('languages', getAllLanguages, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		onSuccess: (languages) => {
			setLanguages(languages);
		},
	});
}
export function useLanguagesByIds() {
	const { setLanguagesByIds } = useLanguagesStore();

	const { mutate, ...rest } = useSWR('languagesByIds', null, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	});

	const fetchLanguagesByIds = async (ids: string[]) => {
		const result = await getLanguagesByIds(ids);

		setLanguagesByIds(result);
		await mutate(result, false);

		return result;
	};

	return { ...rest, fetchLanguagesByIds };
}
